import Vue from 'vue';

export default {
  namespaced: true,
  state: {
    familyMembers: [],
  },
  mutations: {
    setFamilyMembers(state, familyMembers) {
      Vue.set(state, 'familyMembers', familyMembers);
    },
  },
  actions: {
    fetchFamilyMembers({ commit, rootState }) {
      return this.$axios.get(`${rootState.endpoints.filings}/${rootState.filing.currentFilingId}/family-members`).then(response => {
        return commit('setFamilyMembers', response.data);
      }).catch(error => {
        return error.message;
      });
    },
  },
};